<template>
    <div id="pageTable">
        <v-container 
            class="d-flex align-center justify-center" 
            style="height: 80vh; width: 80vw;"
            v-if="rol != 'root' && rol != 'admin' && rol != 'admin-empresa' && rol != 'admin-sucursal'"
        >
			<v-card class="" style="border-radius:20px" max-width="500">
                <v-card-title class="justify-center card_titulo">
                    <div class="headerModal">
                        <img :src="'/static/icon/peligro.svg'" class="imgModal"/>
                    </div>
                </v-card-title>
                <v-card-text class="titleModal text-center">
                    Esta vista no esta disponible para este rol de usuario.
                </v-card-text>
                <v-card-actions class="d-flex align-center justify-center card_accion">
                    <v-btn
                        class="btnGuardar"
                        @click="redireccionar()"
                    >
                        Ok
                    </v-btn>
                </v-card-actions>
            </v-card>
		</v-container>
        <v-container grid-list-xl fluid v-else>
            <v-row>
                <v-col lg="12">
                    <data-table
                        :showAdvancedFilters="true"
                        ref="tableDepartamentos"
                        :tableName="'Departamentos'"
                        :url="url"
                        :columns="columns"
                        :filters="filters"
                        @setFilters="setFilters"
                        @loadModalData="loadModalData"
                        :perPage="[10, 25, 50, 100]"
                    >
                        <template slot="actionButtonsLeft">
                            <div class="botonAgregar" style="padding-right: 12px;" v-if="permisos.create">
                                <v-btn
                                    rounded
                                    color="#004BAF"
                                    class="btnAdd"
                                    right
                                    @click="abrirModal('add')"
                                >
                                    <v-icon dark class="mr-2">add</v-icon>Agregar
                                    <div class="mr-4"></div>
                                </v-btn>
                            </div>
                        </template>

                        <template slot="filters">
                            <v-col cols="12" xs="12" sm="12" md="12" class="py-0">
                                <v-text-field
                                    v-model="nombreDepartamento"
                                    label="Nombre del departamento"
                                    outlined
                                ></v-text-field>
                            </v-col>
                            <template v-if="rol == 'root'">
                                <v-col cols="12" xs="12" sm="6" md="6" class="py-0">
                                    <v-autocomplete
                                        outlined
                                        :items="clientes"
                                        item-text="nombre"
                                        item-value="id"
                                        label="Cliente"
                                        persistent-hint
                                        v-model="cliente_value"
                                    ></v-autocomplete>
                                </v-col>
                            </template>

                            <template v-if="rol == 'root' || rol == 'admin'">
                                <v-col cols="12" xs="12" sm="6" md="6" class="py-0">
                                    <v-autocomplete
                                        outlined
                                        :items="empresas"
                                        item-text="nombre"
                                        item-value="id"
                                        label="Empresa"
                                        persistent-hint
                                        v-model="empresa_value"
                                    ></v-autocomplete>
                                </v-col>
                            </template>

                            <template v-if="rol == 'root' || rol == 'admin' || rol == 'admin-empresa'">
                                <v-col cols="12" xs="12" sm="6" md="6" class="py-0">
                                    <v-autocomplete
                                        outlined
                                        :items="sucursales"
                                        item-text="nombre"
                                        item-value="id"
                                        label="Sucursal"
                                        persistent-hint
                                        v-model="sucursal_value"
                                    ></v-autocomplete>
                                </v-col>
                            </template>
                        </template>

                        <tbody slot="body" slot-scope="{ data }">
                            <tr :key="item.id" v-for="item in data">
                                <td>
                                    <div class="tblPrincipal ml-0">{{ item.nombre }}</div>
                                    <div class="tblSecundario ml-0">{{ item.nombre_empresa }}</div>
                                </td>
                                <td>
                                    <div class="tblPrincipal">{{ item.encargado }}</div>
                                </td>
                                <td>
                                    <div class="tblPrincipal">{{ item.nombre_sucursal }}</div>
                                </td>
                                <td>
                                    <div class="tblOpciones">
                                        <v-tooltip bottom>
                                            <template v-slot:activator="{ on }">
                                                <v-btn
                                                    v-on="on"
                                                    slot="activator"
                                                    class="botonHover"
                                                    icon
                                                    fab
                                                    dark
                                                    small
                                                    @click="abrirModal('dias', item)"
                                                >
                                                    <v-icon class="tamIconoBoton iconoDelgadoBoton">today</v-icon>
                                                </v-btn>
                                            </template>
                                            <span>Dias festivos</span>
                                        </v-tooltip>
                                        <v-tooltip bottom>
                                            <template v-slot:activator="{ on }">
                                                <v-btn
                                                    v-on="on"
                                                    slot="activator"
                                                    class="botonHover"
                                                    icon
                                                    fab
                                                    dark
                                                    small
                                                    @click="abrirModal('update', item)"
                                                >
                                                    <v-icon class="tamIconoBoton invertirColorBotones">edit</v-icon>
                                                </v-btn>
                                            </template>
                                            <span>Editar</span>
                                        </v-tooltip>
                                        <v-tooltip bottom v-if="permisos.delete">
                                            <template v-slot:activator="{ on }">
                                                <v-btn
                                                    v-on="on"
                                                    slot="activator"
                                                    class="botonHover"
                                                    icon
                                                    fab
                                                    dark
                                                    small
                                                    @click="eliminar(item.id, item.nombre)"
                                                >
                                                    <v-icon class="tamIconoBoton invertirColorBotonesDelete">delete</v-icon>
                                                </v-btn>
                                            </template>
                                            <span>Eliminar</span>
                                        </v-tooltip>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </data-table>
                </v-col>
            </v-row>
        </v-container>

        <template v-if="modalRegistro">
            <v-dialog v-model="dialog" persistent max-width="600px" scrollable>
                <template v-slot:activator="{ on }">
                    <v-btn v-on="on" class="botonModal" id="btnModal"></v-btn>
                </template>

                <perfect-scrollbar style="background:#FFF">
                    <v-card elevation="0">
                        <v-card-title class="justify-center card_titulo">
                            <div class="headerModal">
                                <img :src="imagen_depto" class="imgModal" />
                                <h2 class="titleModal">{{ titulo_modal }}</h2>
                            </div>
                        </v-card-title>

                        <v-card-text class="card_texto">
                            <div id="loadingModal" v-show="!finaliza_carga">
                                <div id="loading">
                                    <v-progress-circular
                                        indeterminate
                                        :size="100"
                                        :width="7"
                                        color="blue"
                                    ></v-progress-circular>
                                </div>
                            </div>

                            <v-container v-show="finaliza_carga" grid-list-md id="contenedor">
                                <v-divider class="divider"></v-divider>
                                <v-row>
                                    <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12" class="py-0">
                                        <v-text-field
                                            outlined
                                            autofocus
                                            label="Nombre"
                                            v-model="departamento.nombre"
                                            v-validate="'required'"
                                            data-vv-name="Nombre"
                                            :error-messages="errors.collect('Nombre')"
                                        />
                                    </v-col>
                                    <v-col
                                        cols="12" xs="12" sm="12" md="12" lg="12" xl="12" class="py-0">
                                        <v-text-field
                                            outlined
                                            label="Encargado"
                                            v-model="departamento.encargado"
                                            required
                                            v-validate="'required'"
                                            data-vv-name="Encargado"
                                            :error-messages="errors.collect('Encargado')"
                                        />
                                    </v-col>
                                    <v-col cols="12" xs="12" sm="12" md="12" class="py-0 d-flex">
                                        <div class="textoCorreos">Ingresa los correos de personas que darán seguimiento a las solicitudes del departamento:</div>
                                        <v-tooltip top class="pb-7">
                                            <template v-slot:activator="{ on }">
                                                <v-icon color='#96999A' v-on="on" slot="activator" class="pb-7 pl-2 mr-3 outlined_v_icon">{{'info'}}</v-icon>
                                            </template>
                                            <span class="pb-7 textTooltip">
                                                Ejemplo: jackson.graham@example.com, debra.hold@example.com, michelle.rivera@example.com, geogia.young@example.com
                                            </span>
                                        </v-tooltip>
                                    </v-col>
                                    <v-col cols="12" xs="12" sm="12" md="12" class="py-0">
                                        <v-textarea
                                            outlined
                                            label="Emails"
                                            v-model="departamento.correo"
                                            required
                                            id="Correo"
                                            v-validate="'required'"
                                            data-vv-name="Emails"
                                            :error-messages="errors.collect('Emails')"
                                            rows="3"
                                            :persistent-placeholder="true"
                                            placeholder="jackson.graham@example.com, debra.hold@example.com, michelle.rivera@example.com, geogia.young@example.com"
                                        />
                                    </v-col>
                                    <template v-if="rol == 'root'">
                                        <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12" class="py-0">
                                            <v-autocomplete
                                                outlined
                                                :items="clientes"
                                                item-text="nombre"
                                                item-value="id"
                                                label="Cliente"
                                                persistent-hint
                                                v-model="cliente_value"
                                                v-validate="'required'"
                                                data-vv-name="Cliente"
                                                :error-messages="errors.collect('Cliente')"
                                            />
                                        </v-col>
                                    </template>
                                    <template v-if="rol == 'root' || rol == 'admin'">
                                        <v-col cols="12" xs="12" sm="6" md="6" lg="6" xl="6" class="py-0">
                                            <v-autocomplete
                                                outlined
                                                :items="empresas"
                                                item-text="nombre"
                                                item-value="id"
                                                label="Empresa"
                                                persistent-hint
                                                v-model="empresa_value"
                                                v-validate="'required'"
                                                data-vv-name="Empresa"
                                                :error-messages="errors.collect('Empresa')"
                                            />
                                        </v-col>
                                    </template>
                                    <template v-if="rol == 'root' || rol == 'admin'">
                                        <v-col cols="12" xs="12" sm="6" md="6" lg="6" xl="6" class="py-0">
                                            <v-autocomplete
                                                outlined
                                                :items="sucursales"
                                                item-text="nombre"
                                                item-value="id"
                                                label="Sucursal"
                                                persistent-hint
                                                v-model="sucursal_value"
                                                v-validate="'required'"
                                                data-vv-name="Sucursal"
                                                :error-messages="errors.collect('Sucursal')"
                                                required
                                            />
                                        </v-col>
                                    </template>
                                    <template v-if="rol == 'admin-empresa'">
                                        <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12" class="py-0">
                                            <v-autocomplete
                                                outlined
                                                :items="sucursales"
                                                item-text="nombre"
                                                item-value="id"
                                                class="estiloLetras"
                                                label="Sucursal"
                                                persistent-hint
                                                v-model="sucursal_value"
                                                v-validate="'required'"
                                                data-vv-name="Sucursal"
                                                :error-messages="errors.collect('Sucursal')"
                                                required
                                            />
                                        </v-col>
                                    </template>
                                    <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12" class="py-0">
                                        <v-textarea
                                            outlined
                                            label="Descripción"
                                            name="input-7-4"
                                            v-model="departamento.descripcion"
                                        ></v-textarea>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-card-text>
                        <v-card-actions v-show="finaliza_carga" class="d-flex justify-end card_accion">
                            <button
                                class="btnCerrar"
                                @click="cerrarModal()"
                                :disabled="loading_guardar"
                            >
                                Cancelar
                            </button>
                            <v-btn
                                class="btnGuardar"
                                @click="guardar()"
                                :loading="loading_guardar"
                                v-if="(permisos.update) || (permisos.create && permisos.update == false && accion == 'add')"
                            >
                                Guardar
                            </v-btn>
                        </v-card-actions>

                        <div class="px-15 pb-10" v-if="permisos.update == false && accion == 'update'">
                            <v-alert
                                dense
                                outlined
                                type="error"
                                
                            >
                                El usuario no tiene permiso para editar el registro.
                            </v-alert>
                        </div>
                    </v-card>
                </perfect-scrollbar>
            </v-dialog>
        </template>

        <template v-if="modalDias">
            <v-layout row justify-center>
                <v-dialog v-model="dialog" scrollable persistent max-width="400px">
                    <template v-slot:activator="{ on }">
                        <v-btn v-on="on" class="botonModal" id="btnModal"></v-btn>
                    </template>
                    <perfect-scrollbar style="background:#FFF">
                        <v-card elevation="0">
                            <div>
                                <v-btn
                                    @click="cerrarModal()"
                                    small
                                    slot="activator"
                                    icon
                                    text
                                    class="v-btn-cerrar pull-right mr-3 mt-3"
                                >
                                    <v-icon class="icono-cerrar"></v-icon>
                                </v-btn>
                            </div>

                            <v-card-text class="card_texto">
                                <v-row dense class="pa-0 ma-0">
                                    <v-col
                                        cols="12"
                                        class="my-2 mx-0 py-2 pl-0 pr-2"
                                        style="margin-bottom: -6% !important"
                                    >
                                        <v-list>
                                            <v-list-item two-line class="px-0">
                                                <!-- <v-list-item-avatar
                                                    color="rgba(0, 75, 175, 0.2)"
                                                    width="60"
                                                    height="60"
                                                >
                                                    <v-icon class="icono-calendario"></v-icon>
                                                </v-list-item-avatar> -->
                                                <v-list-item-content style="margin-top: 20px">
                                                    <p class="titleModalDiasFestivos">Días festivos {{ anio_Actual }}</p>
                                                </v-list-item-content>
                                            </v-list-item>
                                        </v-list>
                                    </v-col>

                                    <div id="loadingModal" v-show="!finaliza_carga">
                                        <div id="loading">
                                            <v-progress-circular
                                                indeterminate
                                                :size="70"
                                                :width="7"
                                                color="blue"
                                            ></v-progress-circular>
                                        </div>
                                    </div>

                                    <template
                                        v-if="dias_festivos.length == 0"
                                    >
                                        <v-col cols="12" class="descripcion px-0">
                                            <div style="display: flex; width:100%; justify-content: flex-start;" class="text-center align-center">
                                                <hr class="pipeDiasFestivos"/>
                                                <h1 class="nombreSinDias">Aún no cuenta con días festivos</h1>
                                            </div>
                                            
                                        </v-col>
                                        <v-col cols="12" class="divisionDias" ></v-col>
                                    </template>

                                    <template
                                        v-for="(dia, index) in dias_festivos"
                                        id="DiasFestivos"
                                    >
                                        <v-col cols="12" class="descripcion px-0" :key="index">
                                            <div style="display: flex; width:100%; justify-content: flex-start;">
                                                <hr class="pipeDiasFestivos"/>
                                                <h1 class="nombreDia">{{ dia.nombre }}</h1>
                                            </div>
                                            <!-- <div class="pipeDiasFestivos"></div>
                                            <h1 class="nombreDia">{{ dia.nombre }}</h1> -->
                                            <h1 class="fechas" style="margin-bottom: 15px">
                                                {{ dia.fecha_formateada }}
                                            </h1>
                                            <div class="descripcion">{{ dia.descripcion }}</div>
                                        </v-col>
                                        <v-col cols="12" class="divisionDias" :key="'A'+index"></v-col>
                                    </template>

                                </v-row>
                            </v-card-text>
                        </v-card>
                    </perfect-scrollbar>
                </v-dialog>
            </v-layout>
        </template>
    </div>
</template>

<script>
import clienteAPi from "../api/clientes";
import empresaApi from "../api/empresas";
import sucursalApi from "../api/sucursales";
import departamentoApi from "../api/departamentos";
import Notify from "@/plugins/notify";
import PerfectScrollbar from "perfect-scrollbar";
import Datatable from "@/components/datatable/Datatable.vue";

export default {
    name: "Departamento",
    components: {
        "data-table": Datatable,
    },
    data() {
        return {
            url: "departamentos/find",
            columns: [
                { label: "Nombre del departamento", name: "nombre", filterable: true },
                { label: "Encargado", name: "encargado", filterable: true },
                { label: "Sucursal", name: "sucursal", filterable: true },
                { label: "Opciones", name: "opciones", filterable: false, align: 'center' },
            ],
            filters: {
                activo          : true,
                paginate        : true,
                include_padres  : true,
                empresa_id      : null,
                cliente_id      : null,
                sucursal_id     : null,
                order_by        : 'nombre',
            },
            advancedSearch: {
                nombre          : null,
                encargado       : null,
                descripcion     : null,
                empresa_id      : null,
                cliente_id      : null,
                sucursal_id     : null,
            },
            loading_guardar     : false,
            dialog              : false,
            datosLogin          : "",
            departamento: {
                id              : 0,
                nombre          : "",
                encargado       : "",
                correo          : "",
                descripcion     : "",
                sucursal_id     : null,
                empresa_id      : null,
                cliente_id      : null,
            },
            clientes            : [],
            empresas            : [],
            sucursales          : [],
            titulo_modal        : "",
            finaliza_carga      : false,
            parametros_base     : { activo: true, paginate: false },
            accion              : "",
            modalDias           : false,
            modalRegistro       : false,
            dias_festivos       : [],
            dias                : false,
            cliente_value       : null,
            empresa_value       : null,
            sucursal_value      : null,
            rol                 : null,
            conteo_parametros   : 0,
            imagen_depto        : "/static/modal/departamentoCreate.svg",
            anio_Actual         : "",
            nombreDepartamento  : null,
            permisos :{
                create: false,
                update: false,
                delete: false,
            },
        };
    },
    watch: {
        cliente_value: function (val) {
            if(val != null){
                this.cambiaCliente(val);
            }
        },
        empresa_value: function (val) {
            if(val != null){
                this.cambiaEmpresa(val);
            }
        },
    },
    methods: {
        listar() {
            this.resetValue();
            this.datosLogin = this.$session.get("usuario");
            this.rol = this.datosLogin.rol.name;

            if (this.rol == "admin") {
                this.departamento.cliente_id = this.filters.cliente_id = this.datosLogin.cliente_id;
            } else if (this.rol == "admin-empresa") {
                this.departamento.empresa_id = this.filters.empresa_id = this.datosLogin.empresa_id;
            } else if (this.rol == "admin-sucursal") {
                this.departamento.sucursal_id = this.filters.sucursal_id = this.datosLogin.sucursal_id;
            }
        },
        setFilters() {
            let nombre = this.advancedSearch.nombre;
            let encargado = this.advancedSearch.encargado;
            let descripcion = this.advancedSearch.descripcion;
            let cliente_id = this.cliente_value;
            let empresa_id = this.empresa_value;
            let sucursal_id = this.sucursal_value;

            if (this.rol == "admin") {
                cliente_id = this.datosLogin.cliente_id;
            } else if (this.rol == "admin-empresa") {
                empresa_id = this.datosLogin.empresa_id;
            } else if (this.rol == "admin-sucursal") {
                sucursal_id = this.datosLogin.sucursal_id;
            }

            let filterParams = {
                nombre: nombre,
                encargado: encargado,
                descripcion: descripcion,
                cliente_id: cliente_id,
                empresa_id: empresa_id,
                sucursal_id: sucursal_id,
            };

            let defaultParams = {
                activo: true,
                paginate: true,
                include_padres: true,
            };

            if (filterParams != null) {
                Object.assign(defaultParams, filterParams);
            }

            this.filters = defaultParams;

            this.advancedSearch.nombre = null;
            this.advancedSearch.codigo_postal = null;
            this.advancedSearch.direccion = null;
            this.cliente_value = null;
            this.empresa_value = null;
            this.sucursal_value = null;
        },
        async loadModalData() {
            await this.resetValue();

            if (this.rol == "root") {
                this.getClientes();
            } else if (this.rol == "admin") {
                this.cambiaCliente(this.datosLogin.cliente_id);
                this.cliente_value = this.datosLogin.cliente_id;
            } else if (this.rol == "admin-empresa") {
                this.cambiaEmpresa(this.datosLogin.empresa_id);
                this.cliente_value = this.datosLogin.cliente_id;
                this.empresa_value = this.datosLogin.empresa_id;
            } else if (this.rol == "admin-sucursal") {
                this.cliente_value = this.datosLogin.cliente_id;
                this.empresa_value = this.datosLogin.empresa_id;
                this.sucursal_value = this.datosLogin.sucursal_id;
            }
        },
        setFilters() {
            let cliente         = this.cliente_value;
            let empresa         = this.empresa_value;
            let sucursal        = this.sucursal_value;
            let nombre          = this.nombreDepartamento;

            if (this.rol == "admin") {
                cliente = this.datosLogin.cliente_id;
            } else if (this.rol == "admin-empresa") {
                empresa = this.datosLogin.empresa_id;
            } else if (this.rol == "admin-sucursal") {
                sucursal = this.datosLogin.sucursal_id;
            } else if (this.rol == "admin-depto") {
                departamento = this.datosLogin.departamento_id;
            }

            let filterParams = {
                cliente_id      : cliente,
                empresa_id      : empresa,
                sucursal_id     : sucursal,
                nombre          : nombre
            };

            let defaultParams = {
                activo: true,
                paginate: true,
                include_padres: true,
                order_by        : 'nombre',
            };

            if (filterParams != null) {
                Object.assign(defaultParams, filterParams);
            }

            this.filters = defaultParams;

            this.cliente_value      = null;
            this.empresa_value      = null;
            this.sucursal_value     = null;
            this.nombreDepartamento = null;
            this.clientes           = [];
            this.empresas           = [];
            this.sucursales         = [];

        },
        eliminar(id, depto) {
            Notify.Alert(
                "ADVERTENCIA",
                "¿Esta seguro que desea eliminar el departamento?",
                "Eliminar",
                () => {
                    departamentoApi.deleteDepartamento(id).then((response) => {
                        this.$refs.tableDepartamentos.getData();
                        this.respuesta_ok("El departamento se ha eliminado satisfactoriamente.");
                    })
                    .catch((err) => {
                        this.resetValue();
                        if(typeof err.response.data.error === 'string'){
                            Notify.ErrorToast(err.response.data.error);
                        }else{
                            let error = Object.values(err.response.data.error);
                            let leyenda = ``;

                            for (var i = 0; i < error.length; i++) {
                                leyenda+= `* ` + error[i] + `\n`;
                            }

                            Notify.ErrorToast(leyenda);
                        }
                    });
                }
            );
        },
        scroll() {
            const elementScroll = document.querySelector("#DiasFestivos");
            if (elementScroll) {
                const ps = new PerfectScrollbar(elementScroll, {
                wheelSpeed: 2,
                wheelPropagation: true,
                minScrollbarLength: 20,
                });
            }
        },
        async abrirModal(accion, item = null) {
            this.errors.clear();
            await this.resetValue();
            this.accion = accion;
            this.finaliza_carga = false;
            this.scroll();
            switch (accion) {
                case "add":
                    this.modalDias = false;
                    this.modalRegistro = true;
                    break;
                case "update":
                    this.modalDias = false;
                    this.modalRegistro = true;
                    break;
                case "dias":
                    await this.diasFestivos(item);
                    this.modalDias = true;
                    this.modalRegistro = false;
                    break;
            }

            if (accion == "add") {
                this.titulo_modal = "Registro de departamento";
                this.imagen_depto = "/static/modal/departamentoCreate.svg";
                this.finaliza_parametros();
            } else if (accion == "update") {
                this.titulo_modal = "Actualizar departamento";
                this.imagen_depto = "/static/modal/departamentoUpdate.svg";
                this.departamento.id = item.id;
                this.departamento.nombre = item.nombre;
                this.departamento.encargado = item.encargado;
                this.departamento.correo = item.correo;
                this.departamento.descripcion = item.descripcion;
                this.departamento.cliente_id = item.cliente_id;
                this.departamento.empresa_id = item.empresa_id;
                this.departamento.sucursal_id = item.sucursal_id;
                this.cliente_value = item.cliente_id;
            } else if (accion == "dias") {
                this.titulo_modal = "Dias Festivos";
            }
            if (this.rol == "root") {
                this.getClientes();
                this.finaliza_parametros();
            } else if (this.rol == "admin") {
                this.cambiaCliente(this.datosLogin.cliente_id);
                this.cliente_value = this.datosLogin.cliente_id;
                this.finaliza_parametros();
            } else if (this.rol == "admin-empresa") {
                this.cambiaEmpresa(this.datosLogin.empresa_id);
                this.cliente_value = this.datosLogin.cliente_id;
                this.empresa_value = this.datosLogin.empresa_id;
                this.finaliza_parametros();
            } else if (this.rol == "admin-sucursal") {
                this.sucursal_value = this.datosLogin.sucursal_id;
                this.cliente_value = this.datosLogin.cliente_id;
                this.empresa_value = this.datosLogin.empresa_id;
                this.finaliza_parametros();
            }
            setTimeout(function () {document.getElementById("btnModal").click();}, 100);
        },
        getClientes(cliente = null) {
            let param = { activo: true, paginate: false };
            clienteAPi.getClientes(param).then((response) => {
                this.clientes = response.data;
                this.finaliza_parametros();
            })
            .catch((error) => {
                console.error(err);
                Notify.ErrorToast("Ocurrió un error al cargar los clientes.");
            });
        },
        cambiaCliente(id, cliente = null) {
            if (this.departamento.cliente_id != id) {
                this.empresa_value = null;
                this.departamento.empresa_id = null;
            }

            let parametros = { activo: true, paginate: false, cliente_id: id };
            empresaApi.getEmpresas(parametros).then((response) => {
                this.empresas = response.data;
                if (this.departamento.empresa_id != null) {
                    this.empresa_value = this.departamento.empresa_id;
                    this.finaliza_parametros();
                }
            })
            .catch((error) => {
                console.error(err);
                Notify.ErrorToast("Ocurrió un error al cargar las empresas.");
            });
        },
        cambiaEmpresa(id, sucursal = null) {
            if (this.departamento.empresa_id != id) {
                this.sucursal_value = null;
                this.departamento.sucursal_id = null;
            }
            let parametros = { activo: true, paginate: false, empresa_id: id };
            sucursalApi.getSucursales(parametros).then((response) => {
                this.sucursales = response.data;
                if (this.departamento.sucursal_id != null) {
                    this.sucursal_value = this.departamento.sucursal_id;
                    this.finaliza_parametros();
                }
            })
            .catch((error) => {
                console.error(err);
                Notify.ErrorToast("Ocurrió un error al cargar las sucursales.");
            });
        },
        guardar() {
            this.$validator.validate().then((result) => {
                if (result) {
                    this.loading_guardar = true;
                    if (this.rol == "admin") {
                        this.cliente_value = this.datosLogin.cliente_id;
                    } 
                    else if (this.rol == "admin-empresa") {
                        this.cliente_value = this.datosLogin.cliente_id;
                        this.empresa_value = this.datosLogin.empresa_id;
                    } 
                    else if (this.rol == "admin-sucursal") {
                        this.cliente_value = this.datosLogin.cliente_id;
                        this.empresa_value = this.datosLogin.empresa_id;
                        this.sucursal_value = this.datosLogin.sucursal_id;
                    }

                    this.departamento.cliente_id = this.cliente_value;
                    this.departamento.empresa_id = this.empresa_value;
                    this.departamento.sucursal_id = this.sucursal_value;

                    if (this.accion === "add") {
                        departamentoApi.addDepartamento(this.departamento).then((response) => {
                            this.$refs.tableDepartamentos.getData();
                            this.respuesta_ok("El nuevo departamento se ha guardado satisfactoriamente.");
                        })
                        .catch((error) => {
                            this.respuesta_error(error);
                        });
                    } 
                    else if (this.accion === "update") {
                        departamentoApi.updateDepartamento(this.departamento).then((response) => {
                            this.$refs.tableDepartamentos.getData();
                            this.respuesta_ok("El departamento se actualizó satisfactoriamente.");
                        })
                        .catch((error) => {
                            this.respuesta_error(error);
                        });
                    }
                }
            });
        },
        respuesta_error(err) {
            this.loading_guardar = false;
            if(typeof err.response.data.error === 'string'){
                Notify.ErrorToast(err.response.data.error);
            }else{
                let error = Object.values(err.response.data.error);
                let leyenda = ``;

                for (var i = 0; i < error.length; i++) {
                    leyenda+= `* ` + error[i] + `\n`;
                }

                Notify.ErrorToast(leyenda);
            }
        },
        cerrarModal() {
            this.dialog = false;
            this.resetValue();
        },
        resetValue() {
            this.departamento = {
                id          : 0,
                nombre      : "",
                encargado   : "",
                correo      : "",
                descripcion : "",
                sucursal_id : null,
                empresa_id  : null,
                cliente_id  : null,
            };
            this.value              = null;
            this.dias_festivos      = [];
            this.cliente_value      = null;
            this.empresa_value      = null;
            this.sucursal_value     = null;
            this.conteo_parametros  = 0;
            this.loading_guardar    = false;
            this.clientes           = [];
            this.empresas           = [];
            this.sucursales         = [];
            this.nombreDepartamento = null;
        },
        diasFestivos(data) {
            this.dias = false;
            this.dias_festivos = [];
            departamentoApi.getDepartamento(data.id).then((response) => {
                response.dias_festivos.sort((a, b) => new Date(a.fecha).getTime() - new Date(b.fecha).getTime());
                let formateado = response.dias_festivos;
                formateado.forEach((element) => {
                    if (element["fecha"] != undefined) {
                        element["fecha_formateada"] = element["fecha"].replace(
                            /^(\d{4})-(\d{2})-(\d{2})$/g,
                            "$3/$2/$1"
                        );
                    }
                    this.dias_festivos.push(element);
                    if (this.dias_festivos.length > 0) {
                        this.dias = true;
                    }
                });
                this.finaliza_carga = true;
            })
            .catch((error) => {
                console.error(err);
                Notify.ErrorToast("Ocurrió un error al cargar los departamentos.");
            });
        },
        finaliza_parametros() {
            this.conteo_parametros = this.conteo_parametros + 1;
            if (this.accion == "add" && this.conteo_parametros >= 2) {
                this.finaliza_carga = true;
            }

            if (
                this.accion == "update" &&
                this.conteo_parametros >= 3 &&
                (this.rol == "root" ||
                this.rol == "admin" ||
                this.rol == "admin-empresa")
            ) {
                this.finaliza_carga = true;
            }
            if (
                this.accion == "update" &&
                this.conteo_parametros >= 1 &&
                this.rol == "admin-sucursal"
            ) {
                this.finaliza_carga = true;
            }
        },
        respuesta_ok(msj) {
            this.listar();
            this.cerrarModal();
            this.resetValue();
            this.dialog = false;
            Notify.Success("Operación exitosa", msj);
        },

        init() {
            $(".ps__thumb-x").css("position", "fixed");
            var hoy = new Date();
            this.anio_Actual = hoy.getFullYear();
            /* $("tr th:nth-child(1)").css("padding-left", "5px");
            $("tr th:nth-child(1)").css("padding-right", "5px"); */
            $("tr th:nth-child(1) div:nth-child(1)").css("max-width", "20rem");
            $("tr th:nth-child(1) div:nth-child(1)").css("min-width", "19rem");
            /* $("tr th:nth-child(1) div").css("margin-left", "5px");
            $("tr th:nth-child(1) div").css("margin-right", "5px"); */
            $("tr th:nth-child(1) div:nth-child(1) div").css("max-width", "2rem");
            $("tr th:nth-child(1) div:nth-child(1) div").css("min-width", "1rem");
        },
        redireccionar(){
            this.$router.push('/dashboard');
        },
        permisosVista(){
            let permisosStorage = JSON.parse(sessionStorage.getItem("permisos"))
            this.permisos.create = permisosStorage.includes("departamentos.store")
            this.permisos.update = permisosStorage.includes("departamentos.update")
            this.permisos.delete = permisosStorage.includes("departamentos.delete")
        },
    },
    mounted() {
        this.init();
    },
    created() {
        this.listar();
        this.permisosVista();
    },
};
</script>

<style scoped>
    .titleModalDiasFestivos {
        font-family: 'Montserrat';
        font-style: normal;
        font-weight: 700;
        font-size: 18px;
        line-height: 20px;
        color: #1E2245;
    }
    .fechas {
        font-family: 'Montserrat';
        font-style: normal;
        font-weight: 600;
        font-size: 12px;
        line-height: 15px;
        color: #636997;
        margin-left:12px;
    }

    .descripcion {
        font-family: 'Montserrat';
        font-style: normal;
        font-weight: 500;
        font-size: 12px;
        line-height: 15px;
        text-align: justify;
        color: #828282;
    }
    .divisionDias {
        margin-top: 18px;
        margin-bottom: 12px;
        border-top: solid 1px #c4c4c4;
    }
    .pipeDiasFestivos{
        border: 1px solid #636997;
        background-color: #636997;
        border-radius: 10px;
        height: 30px !important;
        margin-left:0px;
        margin-right: 10px;
    }
    .nombreDia {
        font-family: 'Montserrat';
        font-style: normal;
        font-weight: 600;
        font-size: 16px;
        line-height: 20px;
        color: #828282;
    }
    .nombreSinDias{
        font-family: Montserrat;
        font-style: normal;
        font-weight: 500;
        font-size: 12px;
        line-height: 13px;
        color: #BDBDBD;
    }
    .v-list-item {
        margin-top: -30px !important;
    }
    .v-btn-cerrar .v-btn:hover::before {
        background-color: transparent !important;
        pointer-events: none;
    }
    .v-btn-cerrar .v-btn:hover::after {
        background-color: transparent !important;
        pointer-events: none;
    }
    .v-btn-cerrar .v-btn:hover {
        background-color: transparent !important;
        pointer-events: none;
    }
    .textoCorreos{
        font-family: 'Montserrat';
        font-style: normal;
        font-weight: 600;
        font-size: 14px;
        line-height: 17px;
        color: #828282;
        padding-bottom: 10px;
    }
</style>
